import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { StatisticsData, SummaryData, TableData } from '@app/interfaces/lm/task-test-case';
import { STColumn } from '@app/interfaces/sys/st';
import { ECharts } from 'echarts/core';
import { EChartsOption } from 'echarts/types/dist/shared';

@Component({
  selector: 'app-test-case-progress',
  templateUrl: './test-case-progress.component.html',
  styleUrls: ['./test-case-progress.component.less']
})
export class TestCaseProgressComponent implements OnInit, OnChanges {
    @Input() data!: StatisticsData;
    @Input() isFromTask = true;
    @Output() toDetail = new EventEmitter();
    charts?: ECharts;
    options: EChartsOption = {};
    commonItemStyle = {
        borderColor: '#fff',
        borderWidth: 2,
    };
    tableData: Array<SummaryData | TableData> = this.data?.tableData;

    constructor() {
    }

    ngOnInit(): void {
    }

    async ngOnChanges(changes: SimpleChanges): Promise<void> {
        if (!changes.data) {
           return ;
        }
        this.tableData = this.data?.tableData;
        await this.refreshData();
    }

    format(value: number): string {
        const total = this.data?.total || 0;
        return (value && total ? Math.round(value / total * 100) : 0) + '%';
    }

    async refreshData(): Promise<void> {
        this.updateCharts();
    }

    async onChartInit(charts: ECharts): Promise<void> {
        this.charts = charts;
        this.updateCharts();
    }

    updateCharts(): void {
        const update = () => {
            if (this.charts) {
                this.charts.setOption(this.getChartOptions(), true);
            }
        };
        const ensureUpdate = () => {
            if (!this.charts) {
                setTimeout(ensureUpdate, 500);
                return;
            }
            update();
        };
        ensureUpdate();
    }

    getChartOptions(): EChartsOption {
        this.options = {
            legend: {
                bottom: 2,
                left: 'center',
                type: 'scroll',
                orient: 'horizontal'
            },
            series: [
                {
                    type: 'pie',
                    radius: '70%',
                    minAngle: 5,
                    avoidLabelOverlap: true,
                    center: ['50%', '45%'],
                    label: {},
                    itemStyle: {
                        borderColor: '#fff',
                        borderWidth: 2,
                    },
                    labelLine: {
                        show: true,
                        smooth: 0.2,
                        length: 10,
                        length2: 10
                    },
                    data: this.data?.chartData.filter((item) => item.value) || [],
                },
            ],
        };
        return this.options;
    }

    detail(row: SummaryData): void {
        this.toDetail.emit(row.status);
    }

}
